module.exports = __webpack_public_path__ + "static/media/reuzel.0554367d.png";